import { X, Cookie } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useConsent } from '@/hooks/use-consent';
import { toast } from 'sonner';

export function CookieBanner() {
  const { isPending, acceptConsent, declineConsent } = useConsent();

  if (!isPending) {
    return null;
  }

  const handleAccept = () => {
    acceptConsent();
    toast.success('Preferences enabled', {
      description: 'Your favourites and settings will be saved.',
    });
  };

  const handleDecline = () => {
    declineConsent();
    toast.info('Preferences disabled', {
      description: 'Nothing will be saved. You can change this anytime.',
    });
  };

  return (
    <div className='fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6'>
      <Card className='mx-auto max-w-4xl border-2 shadow-2xl bg-background/95 backdrop-blur-sm'>
        <div className='px-6'>
          <div className='flex items-start gap-4'>
            <div className='shrink-0 rounded-full bg-primary/10 p-3'>
              <Cookie className='h-6 w-6 text-primary' />
            </div>

            <div className='flex-1 space-y-3'>
              <div>
                <h3 className='text-lg font-semibold mb-2'>Browser Storage Notice</h3>
                <p className='text-sm text-muted-foreground leading-relaxed'>
                  We use browser localStorage (not cookies) to save your preferences like favorite tools, theme settings, and tool
                  configurations. All data stays on your device—we don't collect or transmit any personal information. No
                  tracking, no analytics, no third-party services.
                </p>
              </div>

              <div className='flex flex-wrap gap-2'>
                <Button
                  onClick={handleAccept}
                  size='sm'
                >
                  Accept & Continue
                </Button>
                <Button
                  onClick={handleDecline}
                  variant='outline'
                  size='sm'
                >
                  Decline
                </Button>
                <Button
                  variant='ghost'
                  size='sm'
                  onClick={() => {
                    window.location.hash = '/privacy';
                  }}
                >
                  Learn More
                </Button>
              </div>
            </div>

            <Button
              variant='ghost'
              size='icon'
              className='shrink-0'
              onClick={declineConsent}
              aria-label='Close'
            >
              <X className='h-4 w-4' />
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
